import type { RootState } from '../configure-store';

export const selectShowSaveSearchBanner = (state: RootState) =>
    state.ui.showSaveSearchBanner;

export const selectShowAdBlockerMessage = (state: RootState) =>
    state.ui.showAdBlockerMessage;
export const selectShowHeaderSearch = (state: RootState) =>
    state.ui.showHeaderSearch;

export const selectBadges = (state: RootState) => state.ui.badges;
